export class DayWiseProducitonAnalysisModel{
    exportProductsInfo : ExportsProductsInfo[]
    g2ProductsInfo : G2ProductsInfo[]
    jumbleProductsInfo : JumbleProductsInfo[]
    totalCostInInr : number;
    totalRealisationInInr : number;
    plInInr : number;

    constructor( exportProductsInfo : ExportsProductsInfo[],g2ProductsInfo :G2ProductsInfo[],jumbleProductsInfo : JumbleProductsInfo[],totalCostInInr : number,totalRealisationInInr : number,plInInr : number){
        this.exportProductsInfo = exportProductsInfo
        this.g2ProductsInfo = g2ProductsInfo
        this.jumbleProductsInfo = jumbleProductsInfo
        this.totalCostInInr = totalCostInInr
        this.totalRealisationInInr = totalRealisationInInr
        this.plInInr = plInInr
    }
}

export class ExportsProductsInfo{
    product : string
    grade : string
    packStyle : string
    qtyInKgs : number
    costOfSaleInInr : number
    exportValueInInr : number
    plInInr : number

    constructor(product : string,grade : string,packStyle : string,qtyInKgs : number,costOfSaleInInr : number,exportValueInInr : number,plInInr : number){
        this.product = product
        this.grade = grade
        this.packStyle  = packStyle
        this.qtyInKgs = qtyInKgs
        this.costOfSaleInInr = costOfSaleInInr
        this.exportValueInInr = exportValueInInr
        this.plInInr = plInInr
    }
}

export class G2ProductsInfo{
    product : string
    grade : string
    packStyle : string
    qtyInKgs : number
    costOfProduction : number
    realisationInInr : number
    plInInr : number

    constructor(product : string,grade : string,packStyle : string,qtyInKgs : number,costOfProduction : number,realisationInInr : number,plInInr : number){
        this.product = product
        this.grade = grade
        this.packStyle  = packStyle
        this.qtyInKgs = qtyInKgs
        this.costOfProduction = costOfProduction
        this.realisationInInr = realisationInInr
        this.plInInr = plInInr
    }
}

export class JumbleProductsInfo{
    product : string
    grade : string
    packStyle : string
    qtyInKgs : number
    costOfProduction : number

    constructor(product : string,grade : string,packStyle : string,qtyInKgs : number,costOfProduction : number){
        this.product = product
        this.grade = grade
        this.packStyle  = packStyle
        this.qtyInKgs = qtyInKgs
        this.costOfProduction = costOfProduction
    }
}